import endpoints from '../endpoints.ts';
import { Customer, Toast } from '../types/models.ts';
import { fetch } from './helpers.ts';
import { HydratedUser } from '../types/compoundModels.ts';

export namespace UserAPI {
  export namespace Request {
    export interface UpdateOtherSettings {
      firstName: string;
      lastName: string;
      phoneNumber: string;
      userContactId: number | string;
      suspectMedEmailAddress: string | null;
    }
    export interface UpdateEmailAddress {
      totp: string;
      emailAddress: string;
      originalEmailAddress: string;
    }

    export interface CreateEmailAddressToken {
      emailAddress: string;
    }
  }
}

const user = {
  create: {
    emailAddressToken: async (
      params: UserAPI.Request.CreateEmailAddressToken
    ) => {
      const url = endpoints.user.create.emailAddressToken();
      return await fetch<Toast>(url, 'POST', params);
    },
    one: async (body: {
      customerId: number;
      firstName: string;
      lastName: string;
      emailAddress: string;
      title?: string;
    }): Promise<Toast | null> => {
      const url = endpoints.user.create.one();
      return await fetch<Toast>(url, 'POST', body);
    },
  },
  read: {
    customer: async () => {
      const url = endpoints.customer.read.one.by.userId();
      return await fetch<Customer | null>(url, 'GET');
    },
    one: {
      by: {
        id: async (): Promise<HydratedUser | null> => {
          const url = endpoints.user.read.one.by.id();
          return await fetch<HydratedUser>(url, 'GET');
        },
      },
    },
    all: {
      by: {
        customerId: async (): Promise<HydratedUser[] | null> => {
          const url = endpoints.user.read.all.by.customerId();
          return await fetch<HydratedUser[]>(url, 'GET');
        },
      },
    },
    other: {
      by: {
        id: async (userId: number | string): Promise<HydratedUser | null> => {
          const url = endpoints.user.read.other.by.id();
          return await fetch<HydratedUser>(url, 'GET', { userId });
        },
      },
    },
  },
  update: {
    toggleIsActive: async (userId: number | string): Promise<Toast | null> => {
      const url = endpoints.user.update.toggleIsActive();
      return await fetch<Toast>(url, 'PUT', { userId });
    },
    otherSettings: async (
      params: UserAPI.Request.UpdateOtherSettings
    ): Promise<Toast | null> => {
      const url = endpoints.user.update.otherSettings();
      return await fetch<Toast>(url, 'PUT', params);
    },
    emailAddress: async (
      params: UserAPI.Request.UpdateEmailAddress
    ): Promise<Toast | null> => {
      const url = endpoints.user.update.emailAddress();
      return await fetch<Toast>(url, 'PUT', params);
    },

    superAdmin: async (
      currentSuperAdminId: number | string,
      newSuperAdminId: number | string,
      customerId: number | string
    ) => {
      const url = endpoints.user.update.superAdmin();
      return await fetch<Toast>(url, 'PUT', {
        currentSuperAdminId,
        newSuperAdminId,
        customerId,
      });
    },
  },
  get: {
    isAdmin: {
      by: {
        userId: async (params: {
          customerLocationId: number;
        }): Promise<{ isSuperAdmin: boolean; isAdmin: boolean } | null> => {
          const url = endpoints.user.get.isAdmin.by.userId();
          return await fetch<{ isSuperAdmin: boolean; isAdmin: boolean }>(
            url,
            'GET',
            params
          );
        },
      },
    },
  },
  delete: {},
};

export default user;
